//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all cases.
 * @param patientId (optional) 
 * @param ids (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getCases(patientId?: number | null | undefined, ids?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, numberSource?: Types.NumberSource | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfCaseListDto> {
    let url_ = getBaseUrl() + "/api/cases?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (ids !== undefined && ids !== null)
        ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (number !== undefined && number !== null)
        number && number.forEach(item => { url_ += "Number=" + encodeURIComponent("" + item) + "&"; });
    if (numberSource !== undefined && numberSource !== null)
        url_ += "NumberSource=" + encodeURIComponent("" + numberSource) + "&";
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (includeValues === null)
        throw new Error("The parameter 'includeValues' cannot be null.");
    else if (includeValues !== undefined)
        url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCases,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCases?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCases(_response);
    });
}

function processGetCases(response: AxiosResponse): Promise<Types.PageableListDtoOfCaseListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfCaseListDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfCaseListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfCaseListDto>(null as any);
}

/**
 * Creates a case.
 * @param newCase Request parameter
 */
export function createCase(newCase: Types.CreateCaseDto, config?: AxiosRequestConfig | undefined): Promise<Types.CaseDto> {
    let url_ = getBaseUrl() + "/api/cases";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateCaseDto(newCase);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateCase,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateCase?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateCase(_response);
    });
}

function processCreateCase(response: AxiosResponse): Promise<Types.CaseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCaseDto(resultData200);
        return Promise.resolve<Types.CaseDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initCaseDto(resultData201);
        return Promise.resolve<Types.CaseDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CaseDto>(null as any);
}

/**
 * Gets a case by id.
 * @param id The case id.
 */
export function getCase(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.CaseDto> {
    let url_ = getBaseUrl() + "/api/cases/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCase,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCase?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCase(_response);
    });
}

function processGetCase(response: AxiosResponse): Promise<Types.CaseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCaseDto(resultData200);
        return Promise.resolve<Types.CaseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CaseDto>(null as any);
}

/**
 * Edits a case.
 * @param id The case id.
 * @param updatedCase Request parameter
 */
export function editCase(id: number, updatedCase: Types.PatchCaseDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/cases/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchCaseDto(updatedCase);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditCase,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditCase?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditCase(_response);
    });
}

function processEditCase(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes a case.
 * @param id The case id.
 */
export function removeCase(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/cases/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveCase,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveCase?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveCase(_response);
    });
}

function processRemoveCase(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Changes case status to normal.
 * @param id The case id.
 */
export function reopenCase(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/cases/{id}/reopen";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReopenCase,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigReopenCase?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReopenCase(_response);
    });
}

function processReopenCase(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetCases: Partial<AxiosRequestConfig> | null;
export function getGetCasesRequestConfig() {
  return _requestConfigGetCases;
}
export function setGetCasesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCases = value;
}
export function patchGetCasesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCases = patch(_requestConfigGetCases ?? {});
}

let _requestConfigCreateCase: Partial<AxiosRequestConfig> | null;
export function getCreateCaseRequestConfig() {
  return _requestConfigCreateCase;
}
export function setCreateCaseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateCase = value;
}
export function patchCreateCaseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateCase = patch(_requestConfigCreateCase ?? {});
}

let _requestConfigGetCase: Partial<AxiosRequestConfig> | null;
export function getGetCaseRequestConfig() {
  return _requestConfigGetCase;
}
export function setGetCaseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCase = value;
}
export function patchGetCaseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCase = patch(_requestConfigGetCase ?? {});
}

let _requestConfigEditCase: Partial<AxiosRequestConfig> | null;
export function getEditCaseRequestConfig() {
  return _requestConfigEditCase;
}
export function setEditCaseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditCase = value;
}
export function patchEditCaseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditCase = patch(_requestConfigEditCase ?? {});
}

let _requestConfigRemoveCase: Partial<AxiosRequestConfig> | null;
export function getRemoveCaseRequestConfig() {
  return _requestConfigRemoveCase;
}
export function setRemoveCaseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveCase = value;
}
export function patchRemoveCaseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveCase = patch(_requestConfigRemoveCase ?? {});
}

let _requestConfigReopenCase: Partial<AxiosRequestConfig> | null;
export function getReopenCaseRequestConfig() {
  return _requestConfigReopenCase;
}
export function setReopenCaseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReopenCase = value;
}
export function patchReopenCaseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReopenCase = patch(_requestConfigReopenCase ?? {});
}